import React from "react";
import { Button, Modal, Space, Spin, Table, Tooltip } from "antd";
import { sortNames } from "../../sampoorna-siksha/utils/util";
import {
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { AFFL } from "../utils/const";
import AddAffiliate from "./AddAffiliate";
import { exportFile } from "../../common/utils/export";

class Affiliations extends React.Component {
  state = {
    affiliation: {},
  };
  componentDidMount() {
    this.props.fetchMasterTableData(AFFL);
  }

  handleAdd = () => {
    this.setState({ affiliation: {} });
    this.props.toogleAddModal(AFFL);
  };

  edit = (record, e) => {
    e.preventDefault();
    this.setState({ affiliation: record });
    this.props.toogleAddModal(AFFL);
  };

  delete = (record, e) => {
    e.preventDefault();
    const that = this;
    Modal.confirm({
      title: (<div>Do you want to delete this Affiliation?
        <p>Note: It can only be deleted if there are no Institutes mapped to this Affiliation.</p>
      </div>),
      icon: <ExclamationCircleOutlined />,
      onOk() {
        that.props.deleteMasterTableData(AFFL, record.affiliateId);
      },
      onCancel() {},
      okText: "Yes",
      cancelText: "No",
    });
  };

  exportData = (cols) => {
    exportFile(cols, this.props.masterTable.affiliations, "Affiliations");
  };

  render() {
    const AFFL_LIST_COLS = [
      {
        title: "Affiliate",
        dataIndex: "name",
        key: "name",
        render: (text, record) => record.name,
        sorter: {
          compare: (a, b) => sortNames(a.name, b.name),
        },
      },
      {
        title: "Credit System",
        dataIndex: "credSystem",
        key: "credSystem",
        render: (text, record) => record.credSystem === 1 ? "Percentage" : "Grading",
        sorter: {
          compare: (a, b) => sortNames(a.credSystem, b.credSystem),
        },
      },
      {
        title: "Action",
        key: "action",
        render: (text, record) => (
          <Space size="middle">
            <Tooltip title="Edit">
              <a onClick={(e) => this.edit(record, e)}>
                <EditOutlined />
              </a>
            </Tooltip>
            <Tooltip title="Delete">
              <a onClick={(e) => this.delete(record, e)}>
                <DeleteOutlined />
              </a>
            </Tooltip>
          </Space>
        ),
      },
    ];
    return (
      <div id="affiliation-container">
        <h2>
          Affiliations
          <Button
            className="add-cat-button"
            onClick={this.handleAdd}
            type="primary"
            style={{ float: "right" }}
            disabled={this.props.masterTable.loading}
          >
            Add Affiliation
          </Button>
          <Button
            className="add-cat-button"
            onClick={(e) => this.exportData(AFFL_LIST_COLS)}
            style={{ float: "right", marginRight: "10px" }}
            disabled={this.props.masterTable.loading}
          >
            Export Excel
          </Button>
        </h2>
        <Spin spinning={this.props.masterTable.loading} delay={500}>
          <div>
            <Table
              columns={AFFL_LIST_COLS}
              dataSource={this.props.masterTable.affiliations}
              pagination={{
                showSizeChanger: true,
                showTotal: () => {
                  const total = this.props.masterTable.affiliations.length;
                  return `Total ${total}`;
                },
              }}
            />
          </div>
        </Spin>
        {this.props.masterTable.showModal === AFFL && (
          <AddAffiliate record={this.state.affiliation} {...this.props} />
        )}
      </div>
    );
  }
}

export default Affiliations;
